import { Selection, EnterElement } from 'd3';
type SvgEl = Selection<SVGGElement, unknown, HTMLElement, any>;
type EnterSel = Selection<EnterElement, unknown, SVGGElement, unknown>;

interface DrawBarParams {
  identifier: string;
  attr: Record<string, any>;
}

interface DrawParams {
  attr: Record<string, any>;
  styles?: Record<string, any>;
}

export function drawBars(svg: SvgEl, data: any, params: DrawBarParams) {
  const { identifier, attr } = params;
  const bars = svg.selectAll(identifier).data(data).enter().append('rect');

  Object.keys(attr).forEach((k) => {
    bars.attr(k, attr[k]);
  });

  return bars;
}

export function drawLine(svg: SvgEl, data: any, params: DrawParams) {
  const { attr } = params;
  const sel = svg.append('path').datum(data);

  Object.keys(attr).forEach((k) => {
    sel.attr(k, attr[k]);
  });

  return sel;
}

export function drawCircles(svg: SvgEl, data: any, params: DrawParams) {
  const { attr, styles } = params;
  const _attr = attr ?? {};
  const _styles = styles ?? {};
  const sel = svg.append('g').selectAll('dot').data(data).enter().append('circle');

  Object.keys(_attr).forEach((k) => {
    sel.attr(k, _attr[k]);
  });

  Object.keys(_styles).forEach((k) => {
    sel.style(k, _styles[k]);
  });

  return sel;
}

export function drawPath(svg: SvgEl, data: any, params: DrawParams) {
  const { attr, styles } = params;
  const _attr = attr ?? {};
  const _styles = styles ?? {};

  const sel = svg.selectAll('path').data(data).enter().append('path');

  Object.keys(_attr).forEach((k) => {
    sel.attr(k, _attr[k]);
  });

  Object.keys(_styles).forEach((k) => {
    sel.style(k, _styles[k]);
  });

  return sel;
}

export function appendToSelection(sel: EnterSel, type: string, params: DrawParams) {
  const { attr, styles } = params;
  const _attr = attr ?? {};
  const _styles = styles ?? {};

  const el = sel.append(type);

  Object.keys(_attr).forEach((k) => {
    el.attr(k, _attr[k]);
  });

  Object.keys(_styles).forEach((k) => {
    el.style(k, _styles[k]);
  });

  return el;
}

export default {
  drawBars,
  drawLine,
  drawCircles,
  drawPath,
  appendToSelection,
};
